import styled from 'styled-components';
import { Popover } from '../../generic/popover/Popover';
import { ColorPicker } from './ColorPicker';
import { CommonInput } from './CommonInput';

export const ColorInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,

  labelWidth,
  column,

  extended,
  setExtended,
}: {
  id: string;
  label: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string | undefined) => void;

  labelWidth?: number;
  column?: boolean;

  extended?: boolean;
  setExtended?: (newValue: boolean) => void;
}) => {
  return (
    <>
      <CommonInput $labelWidth={labelWidth} key={id} $column={column}>
        <label>{label}</label>
        <input
          type="text"
          id={id}
          placeholder={placeholder}
          value={value || ''}
          onChange={(e: any) => onChange(e.currentTarget.value)}
        />
        <ColorPreviewContainer>
          <Popover
            collisionPadding={55}
            trigger={
              <Checkboard>
                <ColorPreview $color={value || ''} />
              </Checkboard>
            }
          >
            <ColorPicker
              value={value}
              onChange={onChange}
              extended={extended}
              setExtended={setExtended}
            />
          </Popover>
        </ColorPreviewContainer>
      </CommonInput>
    </>
  );
};

const ColorPreviewContainer = styled.div`
  position: absolute;
  bottom: -1px;
  right: 2px;
`;

const Checkboard = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 22px;
  height: 22px;
  margin-left: 5px;

  overflow: hidden;
  border-radius: 50%;
  outline: 1px solid var(--input-border-color);

  transition: outline-color 0.3s ease;
  &:hover {
    outline-color: var(--accent-color);
  }

  background: url('data:image/svg+xml;utf8,<svg preserveAspectRatio="none"  viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><rect x="0" y="0" width="5" height="5" fill="grey" /><rect x="5" y="5" width="5" height="5" fill="grey" /><rect x="5" y="0" width="5" height="5" fill="white" /><rect x="0" y="5" width="5" height="5" fill="white" /></svg>')
    0 0/10px 10px round;
`;

const ColorPreview = styled.div<{ $color: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  ${({ $color }) => $color && `background-color: ${$color};`}
`;
